
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor-ind"  v-model="empresaf" 
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"                              
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-filial_cor">Filial</label> 
                
                <multiselect id="selecao-filial-coe-ind"  v-model="valor_filial"
                  :options="filiaisf" 
                  :multiple="true"                           
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" @input="loadKpiDia(),loadRfiLiberados()" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker> 

                </div>                     
              </b-col>

              
              <!-- 
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2" block @click="loadKpiDia(), loadKpiSituacao(),loadKpiQtd(),loadKpiChassi(),loadKpiStatus(), loadKpiFilial()">
                   carregar
                </b-button>                      
              </b-col>
              -->

          </b-row>
    </b-form>   

    <div>
      
      <b-row>

          <b-col cols=3 class="mt-3">
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="MÉDIA DE DIAS PARADOS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                    {{ kpidiastotal.length > 0 ? (kpidiastotal.map( fp => fp.dias ).reduce(function(anterior,atual){return +anterior+atual ;},0) / kpidiastotal.length).toFixed(0) : 0 }} 
                </h2>
                
              </b-card-text>
      </b-card>        
      </b-col>

      <b-col cols=3 class="mt-3">
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="INDISPONÍVEIS "
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                 {{ kpifuncionario.length>0 ?  kpifuncionario.filter( s => s.status === 'INDISPONIVEL').map(q => q.qtd).join(', ') : 0}} 
                
               
              </h2>
              
            </b-card-text>
          </b-card>
      </b-col>
      
      <b-col cols=3 class="mt-3">
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="LIBERADO(s) "
            header-bg-variant="warning"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                <!-- {{ kpiRfiLiberado.length > 0 ?  kpifuncionario.length : 0}}   -->

                {{kpiRfiLiberado.map(q => q.id).length}}
   
              </h2>
              
            </b-card-text>
          </b-card>
        </b-col>

          <b-col cols=3 class="mt-3">
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="TOTAL "
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{kpiqtds.length}} 
              </h2>
              
            </b-card-text>
          </b-card>
        </b-col>

        <b-col cols=3 class="mt-3">
        </b-col>  

      </b-row>
      
      
    </div>

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="12" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>


        </b-row>

        

        <!-- acumulado  -->
        <b-row>
          
          <!-- acumulado  operador
           -->
          <b-col cols="3">
            <apexcharts
            ref="chartfuncionario" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesfuncionario"
            ></apexcharts>
          </b-col>

          <!-- acumulado  carro -->
          <b-col cols="3">
            <apexcharts 
            ref="chartcarro"
            height="400" :options="graficoCarro" 
            :series="seriescarro"></apexcharts>
          </b-col>

   


          <!-- acumulado  carro -->
          <b-col cols="3">
            <apexcharts 
            ref="chartlinha"
            height="400" :options="graficoLinha" 
            :series="serieschassi"></apexcharts>
          </b-col>

                    <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,                          
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 

   dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    
    
    title: {
      text: 'Carros indiponíveis',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },

  
  /* Tipo de corretiva */
  graficoTipoCorretiva: {
    chart: {
              id: 'bar-tipo',
              type: 'bar',
              height: 350,
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {
//         colors: generateRandomColors() // Gere cores dinamicamente






        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400  // Define uma largura máxima para os rótulos
      },    

          dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

      categories:[], 
      tickPlacement: 'of'            
    },     
    title: {
      text: 'Tipo de corretivas',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  
/* Operador    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'STATUS',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


  
/* Operador    */
  graficoCarro: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'SITUAÇÃO',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  


  /* Linha */
  graficoLinha: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350, 
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {        
        horizontal: true,
       // isFunnel: true,        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400,  // Define uma largura máxima para os rótulos        
      },    

      categories:[], 
      tickPlacement: 'of'            
    },    

    dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    title: {
      text: 'CHASSI',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

    /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350, 
            foreColor:"black",                         
                          //fontFamily: 'Arial, sans-serif', // Defina a fonte desejada
              fontSize: '122px', // Tamanho da fonte      
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
              dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

          title: {
            text: 'INDISPONÍVEL POR FILIAIS',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },


  empresaf:'', 
  empresasf:[],   // [] lista       
  filialf:[],   
  filiaisf:[],   // [] lista   
  valor_filial:[],
  tipo:'',
  tipos:[],


/* objetos */

  kpiqtds:[],
  kpitipos:[],  
  kpidias:[],  
  kpidiastotal:[],            // calcular a média de dias
  kpifuncionario:[] ,
  kpiRfiLiberado:[] ,
  kpichassi:[],
  kpifiliais:[],
  kpicarro:[],
  seriestipo:[],
  seriesdia:[],
  seriesfuncionario:[],
  serieschassi:[],
  seriescarro:[],
  seriesPizzaFilial:[] ,

  dt_inicial: '',
  dt_final: '',  

  sinistros:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfilial:[],  
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {    
      
            loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros           
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.empresaf.map(e => e.id_empresa)}`,       
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros    
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },


      /// qtd corretivas
      async loadKpiQtd() {
            let params = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,        
                "filial_id": `${this.filiaisf.map(f => f.id_filial_erp)}`,                 
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                       
                    "psg": this.user.psg // Adiciona o 'psg' nos parâmetros    
            };
          const url = await `${baseApiUrl}/indicadores/rfi/qtd`
          axios.get(url,{params})
            .then(res => {              
            this.kpiqtds = res.data             
            })
            .catch(showError)
    },


      /// filtros por dia (PERIODO)
      async loadKpiDia() {
            let params = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,        
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                   
              
            };
          const url = await `${baseApiUrl}/indicadores/rfi/periodo`
          axios.get(url,{params})
            .then(res => {              
            this.kpidias = res.data 
            this.updateChartDataDia(); 
            this.loadKpiQtd()
            this.loadKpiChassi(),
            this.loadKpiFilial(), 
            this.loadKpiStatus(), 
            this.loadKpiSituacao(),
            this.loadKpiDiasMedia()
            
            })
            .catch(showError)
    },
    
    async updateChartDataDia() {
       const formattedDates = this.kpidias.map(item => moment(item.dt_parada).format('DD/MM/YYYY'));

      this.seriesdia = [{
        name: 'Qtd RFI',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        categories: formattedDates
        
        //categories: this.kpidias.map(d => d.dt_parada)
        //moment(rfilancamentos.dt_prevista_liberacao).format('DD/MM/YYYY').replace('Data inválida','-')
      }  });       
    },

    async loadKpiDiasMedia() {
            let params = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,     
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                      
            };
          const url = await `${baseApiUrl}/indicadores/rfi/mediadias`
          axios.get(url,{params})
            .then(res => {              
            this.kpidiastotal = res.data             
            })
            .catch(showError)
    },



          /// filtros por tipo 
      async loadKpiTipo() {
            let params = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "tipo_id": `${this.tipo.map(f => f.id)}`,                                
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,   
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                        
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/tipo`
          axios.get(url,{params})
            .then(res => {              
            this.kpitipos = res.data 
            this.updateChartDataTipo();               
            })
            .catch(showError)
    },
    
    async updateChartDataTipo() {
      this.seriestipo = [{
        name: 'Qtd corretivas',
        data: this.kpitipos.map(item => parseInt(item.qtd)),
        }];
      this.$refs.charttipo.updateOptions({ xaxis:{
        categories: this.kpitipos.map(d => d.tipo)
      }  });       
    },


    /// filtros por operador 19/09/2023
      async loadKpiStatus() {
            let params = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,       
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                    
            };
          const url = await `${baseApiUrl}/indicadores/corretiva/status`
          axios.get(url,{params})
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },

        /// filtros por operador 19/09/2023
      async loadRfiLiberados() {
            let params = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial}`,       
                "dt_final": `${this.dt_final}`,    
        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                        
            };
          const url = await `${baseApiUrl}/manutencao/rfi/lancamentosliberados`
          axios.get(url,{params})
            .then(res => {              
            this.kpiRfiLiberado = res.data             
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd sinistros',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.status)
      }  });       
    },

        /// filtros por operador 19/09/2023
      async loadKpiSituacao() {
            let params = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,          
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,        
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                   
            };
          const url = await `${baseApiUrl}/indicadores/rfi/situacao`
          axios.get(url,{params})
            .then(res => {              
            this.kpicarro = res.data 
            this.updateChartDataCarro();               
            })
            .catch(showError)
    },
    
    async updateChartDataCarro() {
      this.seriescarro = [{
        name: 'Qtd indisponíveis',
        data: this.kpicarro.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartcarro.updateOptions({ xaxis:{
        categories: this.kpicarro.map(r => r.situacao)
      }  });       
    },

    /// filtros por Chassi 19/09/2023
    async loadKpiChassi() {
            let params = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`, 
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                          
            };
          const url = await `${baseApiUrl}/indicadores/rfi/chassi`
          axios.get(url,{params})
            .then(res => {              
            this.kpichassi = res.data 
            this.updateChartDataChassi();               
            })
            .catch(showError)
    },
    
    async updateChartDataChassi() {
      this.serieschassi = [{
        name: 'Qtd',
        data: this.kpichassi.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartlinha.updateOptions({ xaxis:{
        categories: this.kpichassi.map(r => r.chassi)
      }  });       
    },

    
      /// filtros por filial
      async loadKpiFilial() {
            let params = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',  
              "id_empresa": `${this.user.id_empresa}`,  
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,       
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,  
                        "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                        
            };
          const url = `${baseApiUrl}/indicadores/rfi/kpifilial`
          axios.get(url,{params})
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();              
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                 
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },












    },




    mounted(){
      this.loadEmpresas()
      this.loadKpiDia()     
      this.loadRfiLiberados()
       
    },

    
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>